// Découpe un texte libre en segments texte / lien pour rendre les URL
// cliquables sans passer par v-html (pas d'injection HTML possible).
export type TextSegment = { type: 'text' | 'link'; value: string; href?: string };

const URL_RE = /(https?:\/\/[^\s<>"]+|www\.[^\s<>"]+)/gi;
// Ponctuation de fin de phrase à ne pas inclure dans le lien.
const TRAILING_PUNCT_RE = /[.,;:!?)\]}'"»]+$/;

export function linkify(text: string): TextSegment[] {
  const segments: TextSegment[] = [];
  let last = 0;
  for (const match of text.matchAll(URL_RE)) {
    const start = match.index ?? 0;
    let url = match[0];
    const trailing = url.match(TRAILING_PUNCT_RE)?.[0] ?? '';
    if (trailing) url = url.slice(0, -trailing.length);
    if (start > last) segments.push({ type: 'text', value: text.slice(last, start) });
    segments.push({ type: 'link', value: url, href: url.startsWith('www.') ? `https://${url}` : url });
    last = start + url.length;
  }
  if (last < text.length) segments.push({ type: 'text', value: text.slice(last) });
  return segments;
}
